import { render } from "./PrivacyPolicy.vue?vue&type=template&id=61c5cd22&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=61c5cd22&scoped=true&lang=css"

import exportComponent from "E:\\H5\\pay_h5_uni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c5cd22"]])

export default __exports__